import PropTypes from "prop-types";

import {
  ParagraphButton,
  Heading1Button,
  Heading2Button,
  Heading3Button,
  FontBoldButton,
  FontItalicButton,
  FontUnderlineButton,
  BulletListButton,
  OrderedListButton,
  BlockQuoteButton,
  LinkButton,
  UndoButton,
  RedoButton,
} from "./Buttons";
import { menuStyles } from "./MenuBar.style";

const propTypes = {
  editor: PropTypes.object,
};

const MenuBar = ({ editor }) => {
  if (!editor) {
    return null;
  }

  return (
    <div css={menuStyles}>
      <ParagraphButton editor={editor} />
      <Heading1Button editor={editor} />
      <Heading2Button editor={editor} />
      <Heading3Button editor={editor} />
      <FontBoldButton editor={editor} />
      <FontItalicButton editor={editor} />
      <FontUnderlineButton editor={editor} />
      <BulletListButton editor={editor} />
      <OrderedListButton editor={editor} />
      <BlockQuoteButton editor={editor} />
      <LinkButton editor={editor} />
      <UndoButton editor={editor} />
      <RedoButton editor={editor} />
    </div>
  );
};

MenuBar.propTypes = propTypes;
export default MenuBar;
